import { render } from "./TabularDatasetsPanel.vue?vue&type=template&id=3b729b73&scoped=true"
import script from "./TabularDatasetsPanel.vue?vue&type=script&lang=js"
export * from "./TabularDatasetsPanel.vue?vue&type=script&lang=js"

import "./TabularDatasetsPanel.vue?vue&type=style&index=0&id=3b729b73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b729b73"]])

export default __exports__